import React from "react";

const FormValidationContext = React.createContext<{
    isValid: boolean
    setIsValid: (b: boolean) => void
}>({
    isValid: true,
    setIsValid: () => { }
});

export const useFormValidation = () => React.useContext(FormValidationContext);

export const FormValidationProvider = ({ children } : Readonly<{ children: React.ReactNode }>) => {
    const [isValid, setIsValid] = React.useState<boolean>(true);
    return (
        <FormValidationContext.Provider value={{
            isValid,
            setIsValid: (b: boolean) => setIsValid(() => b)
        }}>
            {children}
        </FormValidationContext.Provider>
    );
};